const workSatisfactionOptions = [
  {
    name: "Not satisfied at all",
    value: "NOT_SATISFIED",
  },
  {
    name: "Partially satisfied",
    value: "PARTIALLY",
  },
  {
    name: "Very satisfied",
    value: "VERY_SATISFIED",
  },
];

export default workSatisfactionOptions;
